export const useCatalogService = () => {
    const { $catalogService } = useNuxtApp();

    return $catalogService
}